import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { H1, Loading, DeleteButton, AccessCheck } from "@components";
import { useFetchValidationTemplate } from "features/languages/hooks/useFetchValidationTemplate";
import { useFetchValidationRules } from "features/languages/hooks/useFetchValidationRules";
import { validationTemplatesService } from "features/languages/services/validation-templates-services";
import { ValidationTemplateForm } from "features/languages/components/ValidationTemplateForm/ValidationTemplateForm";
import { UserRoleEnum } from "features/users/types";
import type { FormAction } from "features/users/types";
import type { ValidationRules } from "features/languages/types";

export const ValidationTemplateTabPage = ({ action = "read" }: { action?: FormAction }) => {
  const isCreate = action === "create";
  const { id } = useParams();

  const [validationTemplate, isFetching] = useFetchValidationTemplate(Number(id), isCreate);
  const [validationRules, isFetchingRules] = useFetchValidationRules();

  if (isFetching || isFetchingRules) {
    return <Loading />;
  }

  if (!validationTemplate) {
    return null;
  }

  if (!validationRules) {
    return "Could not fetch validation rules.";
  }

  // eslint-disable-next-line no-nested-ternary
  const h1Label = isCreate ? "Create Template" : "Edit Template";

  return (
    <AccessCheck minAccessLevel={UserRoleEnum.Admin}>
      <H1 label={h1Label}>
        <Box sx={{ display: "flex", gap: 3 }}>
          {!isCreate ? (
            <DeleteButton
              id={validationTemplate.id!}
              deleteService={validationTemplatesService.deleteValidationTemplate}
              label="Language"
            />
          ) : null}
        </Box>
      </H1>
      <ValidationTemplateForm
        action={action}
        validationTemplate={validationTemplate}
        validationRules={validationRules as ValidationRules}
      />
    </AccessCheck>
  );
};
